import React from 'react';

import {useIdleTimer} from 'react-idle-timer';

type Props = {
    timeout: number;
    onIdle: () => void;
    startManually: boolean;
    enableTracking?: boolean;

    children: React.ReactElement;
};

function EfeTrack(props: Props) {
    const {children, startManually, enableTracking, timeout, onIdle} = props;

    const {activate} = useIdleTimer({
        startManually,
        onIdle,
        timeout,
        throttle: 500,
    });

    React.useEffect(() => {
        if (enableTracking) {
            activate();
        }
    }, [enableTracking]);

    return <>{children}</>;
}

export default EfeTrack;
